import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { SwitchTransition, Transition } from "react-transition-group";
import { prefersReducedMotion } from "@lib/settings";
const defaultTransitionStyle = {
  transition: "transform 200ms ease, opacity 200ms ease"
};
const transitionStyles: any = {
  entering: {
    opacity: 0,
    transform: "translateY(calc(-10%))",
    ...defaultTransitionStyle
  },
  entered: {
    opacity: 1,
    transform: "translateY(0)",
    ...defaultTransitionStyle
  },
  exiting: {
    opacity: 0,
    ...defaultTransitionStyle
  },
  exited: {
    opacity: 0,
    ...defaultTransitionStyle
  },
  timeout: 200
};
const Fade = t0 => {
  const $ = _c(9);
  const {
    state,
    children
  } = t0;
  const nodeRef = useRef(null);
  if (prefersReducedMotion) {
    const t1 = children || null;
    let t2;
    if ($[0] !== state || $[1] !== t1) {
      t2 = <div className="relative" key={state}>{t1}</div>;
      $[0] = state;
      $[1] = t1;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  const t1 = state > 0;
  let t2;
  if ($[3] !== children) {
    t2 = state_0 => <div ref={nodeRef} className="h-full flex flex-col grow" style={{
      ...transitionStyles[state_0]
    }}>{children}</div>;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== state || $[6] !== t1 || $[7] !== t2) {
    t3 = <SwitchTransition><Transition nodeRef={nodeRef} timeout={200} key={state} appear={t1}>{t2}</Transition></SwitchTransition>;
    $[5] = state;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default Fade;